export default "__VITE_ASSET__8ETLtQN9__"